// import Style from '../../../../../component/popup/style.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const AddPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, Style }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    useEffect(() => {
        console.log("currentData", currentData)
        if (currentData?.id) {
            formik.setFieldValue("date", currentData?.date ? moment(currentData?.date, "DD-MMM-YYYY").format("YYYY-MM-DD") : "")
            formik.setFieldValue("location_id", currentData?.location_id || "")
            formik.setFieldValue("liters_filled", currentData?.liters_filled || "")
            formik.setFieldValue("bill_amount", currentData?.bill_amount ? currentData?.bill_amount?.replaceAll("PKR ", "")?.replaceAll(",", "") : "")
            formik.setFieldValue("vendor_id", currentData?.vendor_id || "")
            formik.setFieldValue("bill_receipt_number", currentData?.bill_receipt_number || "")
            formik.setFieldValue("generator_hours", currentData?.generator_hours || "")
            formik.setFieldValue("notes", currentData?.notes || "")
            formik.setFieldValue("invoice_path", currentData?.invoice_path || "");
        }
    }, [currentData?.id])

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        date: yup.string().required('This Field is required'),
        location_id: yup.string().required('This Field is required'),
        liters_filled: yup.string().required('This Field is required'),
        bill_amount: yup.string().required('This Field is required'),
        vendor_id: yup.string().required('This Field is required'),
        bill_receipt_number: yup.string().required('This Field is required'),
        invoice_path: yup.string().required('This Field is required')
    });

    const formik = useFormik({
        initialValues: {
            date: "",
            location_id: "",
            liters_filled: "",
            bill_amount: "",
            vendor_id: "",
            bill_receipt_number: "",
            generator_hours: "",
            notes: "",
            invoice_path: "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            console.log("Values", values);
            let extraData = {}
            if (currentData?.id) {
                extraData = {
                    "id": currentData?.id
                }
            }
            const apiData = JSON.stringify({
                ...extraData,
                "date": values?.date,
                "location_id": values?.location_id,
                "liters_filled": values?.liters_filled,
                "bill_amount": values?.bill_amount,
                "vendor_id": values?.vendor_id,
                "bill_receipt_number": values?.bill_receipt_number,
                "generator_hours": values?.generator_hours,
                "notes": values?.notes,
                "invoice_path": values?.invoice_path
            });

            try {
                const resp = await apiCall({ method: "post", url: currentData?.id ? `update-fuel-data` : `store-fuel-data`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper>
                            <FormLabel required>Date</FormLabel>
                            <input
                                type={'date'}
                                name={'date'}
                                onChange={formik.handleChange}
                                value={formik.values.date}
                                placeholder='Asset Name'
                            />
                            {formik.touched.date && formik.errors.date && (
                                <FeildError>{formik.errors.date}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Building</FormLabel>

                            <SelectSearch
                                name="location_id"
                                placeholder="- Select Building -"
                                onChange={(val) => {
                                    formik.setFieldValue("location_id", val);
                                }}
                                value={formik.values.location_id}
                                options={dropdowns?.buildings?.map((el) => ({
                                    label: el.name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.location_id && formik.errors.location_id && (
                                <FeildError>{formik.errors.location_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Vendor</FormLabel>

                            <SelectSearch
                                name="vendor_id"
                                placeholder="- Select Vendor -"
                                onChange={(val) => {
                                    formik.setFieldValue("vendor_id", val);
                                }}
                                value={formik.values.vendor_id}
                                options={dropdowns?.vendors?.map((el) => ({
                                    label: el.full_name,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.vendor_id && formik.errors.vendor_id && (
                                <FeildError>{formik.errors.vendor_id}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Liters Filled</FormLabel>
                            <input
                                type={'number'}
                                name={'liters_filled'}
                                onChange={formik.handleChange}
                                value={formik.values.liters_filled}
                                placeholder='Liters Filled'
                            />
                            {formik.touched.liters_filled && formik.errors.liters_filled && (
                                <FeildError>{formik.errors.liters_filled}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Generator Hours</FormLabel>
                            <input
                                type={'number'}
                                name={'generator_hours'}
                                onChange={formik.handleChange}
                                value={formik.values.generator_hours}
                                placeholder='Generator Hours'
                            />
                            {formik.touched.generator_hours && formik.errors.generator_hours && (
                                <FeildError>{formik.errors.generator_hours}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Bill Amount</FormLabel>
                            <input
                                type={'number'}
                                name={'bill_amount'}
                                onChange={formik.handleChange}
                                value={formik.values.bill_amount}
                                placeholder='Bill Amount'
                            />
                            {formik.touched.bill_amount && formik.errors.bill_amount && (
                                <FeildError>{formik.errors.bill_amount}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Bill Receipt Number</FormLabel>
                            <input
                                type={'text'}
                                name={'bill_receipt_number'}
                                onChange={formik.handleChange}
                                value={formik.values.bill_receipt_number}
                                placeholder='Bill Receipt Number'
                            />
                            {formik.touched.bill_receipt_number && formik.errors.bill_receipt_number && (
                                <FeildError>{formik.errors.bill_receipt_number}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel>Notes</FormLabel>

                            <textarea
                                type={'text'}
                                name={'notes'}
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                                placeholder='notes'
                            />
                            {formik.touched.notes && formik.errors.notes && (
                                <FeildError>{formik.errors.notes}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper width='100%'>
                            <FormLabel>Invoice</FormLabel>

                            <FileUploadProgressBar
                                value={formik.values.invoice_path}
                                onChange={(file) => formik.setFieldValue("invoice_path", file)}
                                loader={formik.values.invoice_path}
                            // acceptType="pdf"
                            />
                            {
                                (formik.touched.invoice_path && Boolean(formik.errors.invoice_path)) && (
                                    <FeildError>{formik.touched.invoice_path && formik.errors.invoice_path}</FeildError>
                                )
                            }
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    {
                        (formik?.values?.assignTo || (currentData?.id && currentData?.status == "Assigned" && formik?.values?.status != "Assigned")) ?
                            <p className='text-red-500 text-[14px]'>{formik?.values?.assignTo ? "If you enter an Assign to Date, the asset remains in stock, it gets assigned and then immediately unassigned from the selected user." : "This action will unassign all users from the asset."}</p>
                            :
                            null
                    }
                    {/* <div className={`${Style.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddPopup
